import React from 'react';

import BadgeShowcase from './BadgeShowcase';
import { badgesSet } from './constants';

const Badges = () => (
  <section>
    <article>
      <ul className="showcase-list">
        {
          badgesSet.map((group, i) => (
            <li key={`badge-showcase-${i}`}>
              <BadgeShowcase {...group} />
            </li>
          ))
        }
      </ul>
    </article>
  </section>
);

export default Badges;


// WEBPACK FOOTER //
// ./src/containers/elements/Badges/Badges.js